import AppIcon from "@/common/components/Icons/AppIcon";
import { StringHelper } from "@/common/helpers/string";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { AssessmentFlowDto, AssessmentFlowReferenceDto } from "@/core/api/generated/v1";

import { getContractOptionTitle } from "../Contract/ContractAutocomplete";
import { getVehicleOptionTitleForOperation } from "../Vehicle/VehicleAutocomplete";
import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";

export interface AssessmentFlowInlineProps extends BaseEntityInlineInheritableProps {
  entity: AssessmentFlowDto | AssessmentFlowReferenceDto | null | undefined;
  entityId?: string | null;
}

/** Inline brief information about the assessmentFlow. */
export default function AssessmentFlowInline({
  entity,
  entityId,
  fetch = true,
  ...otherProps
}: AssessmentFlowInlineProps) {
  const request = useApiRequest(
    apiClient.assessmentFlowsApi.apiV1FlowsAssessmentFlowsAssessmentFlowIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      assessmentFlowId: entityId!,
    },
    {
      deps: [entityId],
      skip: !fetch || !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  const full = entity as AssessmentFlowDto;
  // const ref = entity as AssessmentFlowReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={fetch ? request : undefined}
      icon={<AppIcon of='assessmentFlow' inText />}
      content={
        <>
          {StringHelper.join(
            [
              entity?.localNumber,
              full?.vehicle && getVehicleOptionTitleForOperation(full.vehicle),
              full?.contract && getContractOptionTitle(full.contract),
              "Damages & approvals",
            ],
            " | ",
            {
              skipEmpty: true,
            },
          )}
        </>
      }
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Damage & approvals"}
    />
  );
}
